


















import {Component, Emit, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import TinyMce from '@/components/admin/TinyMce.vue'
import EventPage from "@/models/EventPage"

@Component({
  components: {
    TinyMce
  }
})
export default class EventPageForm extends VueBase {
  @Prop(Object) readonly value!: EventPage

  @Emit('input')
  input(value: EventPage): EventPage {
    return value
  }

  @Emit()
  onSave(): EventPage {
    return this.value
  }

  get internalValue(): EventPage {
    return this.value
  }

  set internalValue(val: EventPage) {
    this.input(val)
  }

  items = [{text: '公開中', value: 'publish'}, {text: '下書き', value: 'draft'}, {text: '終了', value: 'private'}]
}
